<template lang="pug">
a#widget.floating-widget(:class="{'d-none': hideFloat == true}" href="javascript:void(0)")
  button#closeBtn.close-btn(style="z-index: 2" @click="closeFloat()") &times;
  //- img(src='/new/img/september-upgrade-badge.gif' alt='September 1 upgrade countdown' @click="$router.push('/migration').catch(err => {})")
  img(src='/new/img/migration-live.gif' alt='September 1 upgrade countdown' @click="$router.push('/migration').catch(err => {})")
  //- .countdown-wrap
    .shine
    //- #countdown.countdown {{ daysLeft }} days left
    #countdown.countdown LIVE NOW
</template>
<script>
export default{
  data(){
    return{
      hideFloat: false
    }
  },
  computed: {
    daysLeft() {
      const targetDate = this.$moment(`${this.$moment().year()}-09-01`)

      return Math.max(
        0,
        Math.ceil(targetDate.diff(this.$moment(), 'days', true))
      )
    }
  },
  methods:{
    closeFloat(){
      this.hideFloat = true
    }
  }
}
</script>
<style lang="scss" scoped>
.floating-widget {
  position: fixed;
  right: 18px;
  bottom: 18px;
  width: 130px;
  height: 130px;
  display: block;
  cursor: pointer;
  text-decoration: none;
  animation: float 3s ease-in-out infinite;
  z-index: 9999;
  @media(max-width: 767px) {
    bottom: 65px;
  }
}

.floating-widget:hover {
  transform: scale(1.06);
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.floating-widget::before {
  content: '';
  position: absolute;
  inset: 6px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(216, 180, 254, 0.65) 0%, rgba(168, 85, 247, 0) 70%);
  animation: pulse-glow 2.2s ease-in-out infinite;
  z-index: -1;
}

@keyframes pulse-glow {
  0%, 100% { transform: scale(0.85); opacity: 0.55; }
  50% { transform: scale(1.2); opacity: 1; }
}

.floating-widget img {
  width: 100%;
  height: 100%;
  display: block;
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.45));
}

.close-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1a1030;
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  z-index: 10;
}

.countdown-wrap {
  position: absolute;
  left: 50%;
  bottom: 2%;
  transform: translateX(-50%);
  width: 83%;
  height: 21%;
  border-radius: 18px;
  overflow: hidden;
  pointer-events: none;
  background: #000;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.shine {
  position: absolute;
  top: 0;
  left: -60%;
  width: 35%;
  height: 100%;
  background: linear-gradient(115deg, transparent, rgba(255, 255, 255, 0.65), transparent);
  transform: skewX(-20deg);
  animation: shine-sweep 3s ease-in-out infinite;
  z-index: 1;
}

@keyframes shine-sweep {
  0% { left: -60%; }
  45% { left: 120%; }
  100% { left: 120%; }
}

.countdown {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #22ff6e;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-shadow: 0 0 6px rgba(34, 255, 110, 0.75);
  z-index: 2;
  animation: text-pulse 2.2s ease-in-out infinite;
}

@keyframes text-pulse {
  0%, 100% { text-shadow: 0 0 6px rgba(34, 255, 110, 0.75); }
  50% { text-shadow: 0 0 12px rgba(34, 255, 110, 1), 0 0 4px rgba(255, 255, 255, 0.8); }
}

.countdown.live {
  font-size: 13px;
  letter-spacing: 1.5px;
}
</style>